module.exports = __webpack_public_path__ + "dimer/static/img/t$eImg4.534f0e0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/t$eImg4.jpg
// module id = ZS3A
// module chunks = 0